import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

// Read a previously saved session (if any) so a page reload doesn't log
// the user out. Wrapped in try/catch because localStorage can throw in
// some private-browsing modes.
function loadStoredUser() {
  try {
    const username = localStorage.getItem("cur_username");
    const token = localStorage.getItem("cur_token");
    const fullName = localStorage.getItem("cur_fullname") || "";
    if (username && token) {
      return { username, token, fullName };
    }
  } catch (e) {
    // ignore - user will just have to log in again
  }
  return null;
}

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(loadStoredUser);

  // Called after a successful login with the token issued by login.php.
  const login = (username, token, fullName) => {
    setCurrentUser({ username, token, fullName: fullName || "" });
    try {
      localStorage.setItem("cur_username", username);
      localStorage.setItem("cur_token", token);
      localStorage.setItem("cur_fullname", fullName || "");
    } catch (e) {
      // ignore
    }
  };

  // Called after the name is changed via profile.php, so the UI + storage
  // stay in sync without requiring a fresh login.
  const updateFullName = (fullName) => {
    setCurrentUser((prev) => (prev ? { ...prev, fullName: fullName || "" } : prev));
    try {
      localStorage.setItem("cur_fullname", fullName || "");
    } catch (e) {
      // ignore
    }
  };

  const logout = () => {
    setCurrentUser(null);
    try {
      localStorage.removeItem("cur_username");
      localStorage.removeItem("cur_token");
      localStorage.removeItem("cur_fullname");
    } catch (e) {
      // ignore
    }
  };

  const value = { currentUser, login, logout, updateFullName };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
